import type { SerializableRecord } from '~~/lib/ContentfulTransformerService/model';

export function isSerializableRecord(
  value: unknown
): value is SerializableRecord {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}
